module.exports = __webpack_public_path__ + "media/images/lb/468-e97fbe5efc2b18e9d80ef554b3e59c77.svg";